import SliderCounter from './slider-counter.js';
import { tns } from "./../../../../node_modules/tiny-slider/src/tiny-slider";

export default class Gallery {

    items = [];
    imagesSlider = null;
    sliderContainer = null;
    modal = document.querySelector('[data-popup-modal="gallery"]');
    container = this.modal.querySelector('.gallery-container');
    sliderCounter = null;

    constructor(config) {
        this.prepareConfig(config);
        this.sliderCounter = new SliderCounter();
        this.init();
    }

    prepareConfig = (config) => {
        if (typeof config === 'object') {
            this.items = config;
        }
    }

    init = () => {
        const { items, container } = this;

        this.sliderContainer = document.createElement('div');

        items.forEach(item => {
            const div = document.createElement('div');
            div.classList.add('gallery-item');
            const img = document.createElement('img');
            img.src = item;

            div.appendChild(img);
            this.sliderContainer.appendChild(div);
        });
        container.appendChild(this.sliderContainer);

        this.prepareSlider();
    }

    open = (slideIndex = null) => {
        if (slideIndex !== null) {
            this.imagesSlider.goTo(slideIndex);
        }

        modal.open('gallery');
    }

    prepareSlider = () => {
        this.imagesSlider = tns({
            preventScrollOnTouch: 'force',
            container: this.sliderContainer,
            items: 1,
            nav: false,
            autoHeight: false,
            mouseDrag: true,
            center: true,
            controls: true,
            swipeAngle: false,
            arrowKeys: true
        });

        if (this.imagesSlider !== undefined) {
            this.imagesSlider.events.on('indexChanged', (data, eventName) => {
                this.sliderCounter.add(data);
            });
        }
    }
}